import { useFetch } from "../../lib/useData";
import CrudManager from "../../components/admin/CrudManager";

export function DeitiesAdmin() {
  return <CrudManager title="Deities" desc="Manage the temple's deities & sacred idols" collection="deities" module="deities"
    uniqueFields={[{ name: "display_order", label: "Order" }]}
    columns={[{ key: "image", label: "Image", image: true }, { key: "name", label: "Name" }, { key: "display_order", label: "Order" }]}
    fields={[
      { name: "name", label: "Name *", span: 2 },
      { name: "slug", label: "Slug (url)", hint: "e.g. shri-hanuman-ji" },
      { name: "display_order", label: "Display Order", type: "number" },
{ name: "image", label: "Image", type: "image", span: 2 },
      { name: "short_description", label: "Short Description", type: "textarea", span: 2 },
      { name: "significance", label: "Spiritual Significance (temple-approved)", type: "textarea", span: 2, rows: 5 },
      { name: "status", label: "Status", type: "status" },
    ]} />;
}

export function JourneyAdmin() {
  return <CrudManager title="Our Journey" desc="Timeline milestones" collection="journey" module="journey"
      uniqueFields={[{ name: "display_order", label: "Order" }]}

    columns={[{ key: "year", label: "Year" }, { key: "title", label: "Title" }, { key: "display_order", label: "Order" }]}
    fields={[
      { name: "year", label: "Year *" }, { name: "display_order", label: "Order", type: "number" },
      { name: "title", label: "Title *", span: 2 },
      { name: "description", label: "Description", type: "textarea", span: 2 },
{ name: "image", label: "Image", type: "image", span: 2 },
      { name: "status", label: "Status", type: "status" },
    ]} />;
}

export function SevaCategoriesAdmin() {
  return <CrudManager title="Seva Categories" collection="seva_categories" module="seva"
    columns={[{ key: "name", label: "Name" }, { key: "slug", label: "Slug" }, { key: "display_order", label: "Order" }]}
    fields={[
      { name: "name", label: "Name *" }, { name: "slug", label: "Slug" },
      { name: "description", label: "Description", type: "textarea", span: 2 },
      { name: "display_order", label: "Order", type: "number" },
      { name: "status", label: "Status", type: "status" },
    ]} />;
}

export function NewsAdmin() {
  return <CrudManager title="News" desc="News articles" collection="news" module="news"
    columns={[{ key: "title", label: "Title" }, { key: "category", label: "Category" }, { key: "date", label: "Date" }]}
    fields={[
      { name: "title", label: "Title *", span: 2 }, { name: "slug", label: "Slug" },
      { name: "category", label: "Category" }, { name: "date", label: "Date", type: "text", hint: "YYYY-MM-DD" },
{ name: "featured_image", label: "Image", type: "image", span: 2 },
      { name: "short_description", label: "Short Description", type: "textarea", span: 2 },
      { name: "content", label: "Full Content", type: "textarea", span: 2, rows: 6 },
      { name: "status", label: "Status", type: "status" },
    ]} />;
}

export function AnnouncementsAdmin() {
  return <CrudManager title="Announcements" desc="Short notices. Mark urgent to show on homepage banner." collection="announcements" module="news" defaults={{ urgent: false }}
    columns={[{ key: "title", label: "Announcement" }, { key: "urgent", label: "Urgent", render: (v) => (v ? "Yes" : "No") }]}
    fields={[
      { name: "title", label: "Announcement Text *", type: "textarea", span: 2 },
      { name: "urgent", label: "Urgent (homepage banner)", type: "select", options: [{ value: true, label: "Yes" }, { value: false, label: "No" }] },
      { name: "status", label: "Status", type: "status" },
    ]} />;
}

export function SocialAdmin() {
  return <CrudManager title="Social Service" desc="Gau Seva & community initiatives" collection="social_service" module="social"
    columns={[{ key: "image", label: "Image", image: true }, { key: "title", label: "Title" }]}
    fields={[
      { name: "title", label: "Title *", span: 2 }, { name: "slug", label: "Slug" },
      { name: "display_order", label: "Order", type: "number" },
{ name: "image", label: "Image", type: "image", span: 2 },
      { name: "description", label: "Description", type: "textarea", span: 2, rows: 5 },
      { name: "status", label: "Status", type: "status" },
    ]} />;
}

export function GalleryAdmin() {
  return <CrudManager title="Gallery" desc="Manage photos & categories" collection="gallery" module="gallery"
    columns={[{ key: "image", label: "Image", image: true }, { key: "title", label: "Title" }, { key: "category", label: "Category" }]}
    fields={[
      { name: "title", label: "Title *" },
      { name: "category", label: "Category", type: "select", options: ["Temple", "Deities", "Festivals", "Seva", "Social Service", "Events", "Other"] },
{ name: "image", label: "Image", type: "image", span: 2 },
      { name: "alt_text", label: "Alt Text (accessibility)" }, { name: "caption", label: "Caption" },
      { name: "display_order", label: "Order", type: "number" },
      { name: "status", label: "Status", type: "status" },
    ]} />;
}

export function FaqAdmin() {
  return <CrudManager title="FAQ" desc="Frequently asked questions" collection="faqs" module="faq"
    columns={[{ key: "question", label: "Question" }, { key: "category", label: "Category" }, { key: "display_order", label: "Order" }]}
    fields={[
      { name: "question", label: "Question *", span: 2 },
      { name: "answer", label: "Answer", type: "textarea", span: 2 },
      { name: "category", label: "Category" }, { name: "display_order", label: "Order", type: "number" },
      { name: "status", label: "Status", type: "status" },
    ]} />;
}

export function LegalAdmin() {
  return <CrudManager title="Legal Pages" desc="Privacy, Terms, Refund, Disclaimer, Cookies" collection="legal_pages" module="content"
    columns={[{ key: "title", label: "Page" }, { key: "slug", label: "Slug" }]}
    fields={[
      { name: "title", label: "Title *" }, { name: "slug", label: "Slug" },
      { name: "content", label: "Content (temple-approved)", type: "textarea", span: 2, rows: 10 },
      { name: "status", label: "Status", type: "status" },
    ]} />;
}
